// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"50":"2b9ddeba","273":"4fa75912","417":"38131554","622":"99bef347","832":"29e3262e","890":"9cad1c07"}[chunkId] + ".js";
};